import LabelFieldFactory from 'browser/components/atomic-elements/higher-order-components/label-field-factory'
import { ImageInput } from 'browser/components/json-elements/atoms/image-input/image-input'
export const UIImageField = LabelFieldFactory({ InputComponent: ImageInput })
